module.exports = __webpack_public_path__ + "static/Cel1ES-a9c96d2ca4a3884e514fe25c81cd3752.webm";